// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buybox-row[data-v-13adecbe]{display:flex;align-items:stretch;width:100%}.buybox-row[data-v-13adecbe]:last-of-type{margin-bottom:16px}.buybox-row__label[data-v-13adecbe]{margin:1px 0 0;padding:16px 4px;min-height:90px;font-size:14px;font-weight:400;line-height:100%;letter-spacing:.24px;text-transform:uppercase;flex-shrink:0;display:flex;align-items:center;justify-content:center;writing-mode:vertical-lr;transform:rotate(180deg);color:#797a7b;background:#e6e6e6}", ""]);
// Exports
module.exports = exports;
